wbApp.directive('wbPaymentEdit', ['$timeout', '$translate', 'invoiceSvc', 'paymentsSvc', 'reservationsSvc',
    function ($timeout, $translate, invoiceSvc, paymentsSvc, reservationsSvc) {

        return {
            restrict: 'A',
          //  require: '^ngModel',
            scope: {
                model: '=ngModel',
                isAddBankPayment: '=',
                isAddDuePayment: '=',
                isOnlinePayment: '='
            },
            templateUrl: 'directives/payment-edit/payment-edit.html',
            controller: ['$scope', '$element', function ($scope, $element) {

                var studentChangedFromInvoice = false;

                $scope.onInvoiceForTypeChange = function () {
                    paymentsSvc.clearPaymentEditModel($scope.model, $scope.isAddBankPayment, $scope.isAddDuePayment, $scope.isOnlinePayment);
                }

                $scope.onInvoiceChange = function (invoiceForType, invoiceID) {
                    if (!invoiceID) {
                        return;
                    }

                    if (invoiceForType == 4) // Reservations
                    {
                        var res = reservationsSvc.getByInvoice(invoiceID);
                        res.then(function (data) {
                            fillCombosForReservations([data], false);
                        });
                    }
                    else {
                        var res = invoiceSvc.getPaymentDetailsByInvoice(invoiceForType, invoiceID);
                        res.$promise.then(function (data) {
                            $scope.model.studentID = data.studentID;
                            fillCombos(data);
                        });
                    }
                }

                $scope.onSemesterChange = function (semesterID) {
                    changeSemester(0, semesterID, 0, 0);
                }

                $scope.onCourseChange = function (courseID) {
                    changeCourse(courseID);
                }

                $scope.onActivityChange = function (activityID) {
                    changeActivity(activityID, 0);
                }

                $scope.onActivityReconciliationChange = function (activityReconciliationID) {
                    changeActivityReconciliation(activityReconciliationID);
                }

                $scope.onActivityReccurenceScheduleChange = function (issuedInvoiceID) {
                    changeActivityReccurenceSchedule(issuedInvoiceID);
                }

                $scope.onReservationChange = function (reservationId) {
                    var reservation = _.find($scope.model.reservations, { id: reservationId });
                    if (!!reservation) {
                        $scope.model.invoiceID = reservation.invoice.id;
                        $scope.model.amount = reservation.invoice.arrear;
                        $scope.model.notes = reservation.notes;
                    }
                }

                $scope.onStudentChange = function (invoiceForType, studentID) {
                    if (!studentID) {
                        return;
                    }

                    if (studentChangedFromInvoice) {
                        studentChangedFromInvoice = false;
                        return;
                    } else
                    {
                        $scope.model.invoiceID = null;
                    }

                    if (invoiceForType == 4) // Reservations
                    {
                        var res = reservationsSvc.getAllByRangeAndStudent(
                            studentID,
                            new Date(2000, 0, 1),
                            new Date(3000, 0, 1));
                        res.then(function (data) {
                            fillCombosForReservations(data, true);
                        });
                    }
                    else {
                        var res = invoiceSvc.getPaymentDetailsByStudent(invoiceForType, studentID);
                        res.$promise.then(function (data) {
                            fillCombos(data);
                        });
                    }
                }

                function fillCombosForReservations(reservations, isInStudentSelection)
                {
                    $scope.model.reservations.length = 0;
                    $scope.model.reservations.push.apply($scope.model.reservations, reservations);

                    var first = _.first(reservations);
                    if (!first) {
                        $scope.model.reservationId = null;
                        return;
                    }

                    $scope.model.reservationId = first.id;

                    var newStudentId = _.first(first.studentIds);
                    if (!isInStudentSelection && $scope.model.studentID != newStudentId) {
                        studentChangedFromInvoice = true;
                        $scope.model.studentID = newStudentId;                            
                    }

                    if (isInStudentSelection) {
                        $scope.model.invoiceID = first.invoice.id;
                    }

                    $scope.model.amount = first.invoice.arrear;
                    $scope.model.notes = first.notes;
                }

                function fillCombos(data) {
                    $scope.model.semesters.length = 0;
                    $scope.model.semesters.push.apply($scope.model.semesters, data.semesters);
                    $scope.model.semesterID = selectSemesterID($scope.model.semesters, data.selectedSemesterID);

                    if ($scope.model.invoiceForType != 4) {
                        changeSemester(data.selectedCourseID, $scope.model.semesterID, data.selectedActivityID, data.selectedActivityReconciliationID, data.selectedInvoiceID);
                    } else {
                        changeReservation(data.reservationID, data.selectedInvoiceID);
                    }
                }

                function changeReservation(reservationID, selectedInvoiceID) {

                }

                function changeSemester(courseID, semesterID, activityID, activityReconciliationID, selectedInvoiceID) {
                    var semester = findSemester($scope.model.semesters, semesterID);
                    if (semester) {
                        $scope.model.courses.length = 0;
                        $scope.model.activities.length = 0;
                        if ($scope.model.invoiceForType === 3) {
                            $scope.model.activities.push.apply($scope.model.activities, semester.activities);
                            $scope.model.activityID = selectActivityID($scope.model.activities, activityID);
                            changeActivity($scope.model.activityID, activityReconciliationID, selectedInvoiceID);
                        } else {
                            $scope.model.courses.push.apply($scope.model.courses, semester.courses);
                            $scope.model.courseID = selectCourseID($scope.model.courses, courseID);
                            changeCourse($scope.model.courseID);
                        }
                    } else {
                        alert('Semester not found');
                    }
                }

                function changeActivity(activityID, activityReconciliationID, selectedInvoiceID) {
                    var activity = findActivity($scope.model.activities, activityID);
                    if (activity) {
                        $scope.model.reconciliations.length = 0;
                        $scope.model.reconciliations.push.apply($scope.model.reconciliations, activity.reconciliations);
                        $scope.model.reccurenceSchedules.length = 0;
                        $scope.model.reccurenceSchedules.push.apply($scope.model.reccurenceSchedules, activity.reccurenceSchedules);

                        var issued = _.find($scope.model.reccurenceSchedules, { invoiceID: selectedInvoiceID });

                        if (!issued && $scope.model.reconciliations.length > 0) {
                            $scope.model.activityReconciliationID = selectActivityReconciliationID($scope.model.reconciliations, activityReconciliationID);
                            if (!!$scope.model.activityReconciliationID) {
                                changeActivityReconciliation($scope.model.activityReconciliationID);
                            }
                        } else {
                            $scope.model.activityReconciliationID = 0;
                            if ($scope.model.reccurenceSchedules.length > 0) {
                                var issued = issued || $scope.model.reccurenceSchedules[0];
                                $scope.model.issuedInvoiceID = issued.invoiceID;
                                if (!$scope.isAddBankPayment && !$scope.isOnlinePayment) {
                                    $scope.model.amount = Math.max(0, issued.price - issued.paymentSum);
                                    $scope.model.notes = "";
                                }
                                if ($scope.model.invoiceID !== $scope.model.issuedInvoiceID) {
                                    $scope.model.invoiceID = $scope.model.issuedInvoiceID;
                                }
                            } else  {
                                if (!$scope.isAddBankPayment && !$scope.isOnlinePayment) {
                                    $scope.model.amount = 0;
                                }
                                $scope.model.notes = "";
                                if ($scope.model.invoiceID !== 0) {
                                    $scope.model.invoiceID = 0;
                                }
                            }
                        }
                    }
                }

                function changeCourse(courseID) {
                    var course = findCourse($scope.model.courses, courseID);
                    if (course) {
                        if (!$scope.isAddBankPayment && !$scope.isOnlinePayment) {
                            $scope.model.amount = Math.max(0, course.price - course.paymentSum);
                        }
                        $scope.model.notes = course.registrationNote;
                        var newInvoiceID = !course.invoiceID ? 0 : course.invoiceID;
                        if ($scope.model.invoiceID !== newInvoiceID) {
                            $scope.model.invoiceID = newInvoiceID;
                        }
                    } else {
                        if (!$scope.isAddBankPayment && !$scope.isOnlinePayment) {
                            $scope.model.amount = 0;
                        }
                        $scope.model.notes = "";
                        if ($scope.model.invoiceID !== 0) {
                            $scope.model.invoiceID = 0;
                        }
                    }
                }

                function changeActivityReccurenceSchedule(issuedInvoiceID) {
                    var schedule = _.find($scope.model.reccurenceSchedules, { invoiceID: issuedInvoiceID + "" });
                    if (schedule) {
                        if (!$scope.isAddBankPayment && !$scope.isOnlinePayment) {
                            $scope.model.amount = Math.max(0, schedule.price - schedule.paymentSum);
                        }
                        $scope.model.notes = "";
                        if ($scope.model.invoiceID !== schedule.invoiceID) {
                            $scope.model.invoiceID = schedule.invoiceID;
                        }
                        $scope.model.activityReconciliationID = 0;
                    } else {
                        if (!$scope.isAddBankPayment && !$scope.isOnlinePayment) {
                            $scope.model.amount = 0;
                        }
                        $scope.model.notes = "";
                        if ($scope.model.invoiceID !== 0) {
                            $scope.model.invoiceID = 0;
                        }
                    }
                }

                function changeActivityReconciliation(activityReconciliationID) {
                    var reconciliation = findReconciliation($scope.model.reconciliations, activityReconciliationID);
                    if (reconciliation) {
                        if (!$scope.isAddBankPayment && !$scope.isOnlinePayment) {
                            $scope.model.amount = Math.max(0, reconciliation.price - reconciliation.paymentSum);
                        }
                        $scope.model.notes = reconciliation.notes;
                        var newInvoiceID = !reconciliation.invoiceID ? 0 : reconciliation.invoiceID;
                        if ($scope.model.invoiceID !== newInvoiceID) {
                            $scope.model.invoiceID = newInvoiceID;
                            $scope.model.issuedInvoiceID = 0;
                        }
                    } else {
                        if (!$scope.isAddBankPayment && !$scope.isOnlinePayment) {
                            $scope.model.amount = 0;
                        }
                        $scope.model.notes = "";
                        if ($scope.model.invoiceID !== 0) {
                            $scope.model.invoiceID = 0;
                        }
                    }
                }

                function findReconciliation(reconciliations, activityReconciliationID) {
                    return findByID(reconciliations, activityReconciliationID, "activityReconciliationID");
                }

                function findCourse(courses, courseID) {
                    return findByID(courses, courseID, "courseID");
                }

                function findSemester(semesters, semesterID) {
                    var res = findByID(semesters, semesterID, "semesterID");
                    if (res) {
                        return res;
                    }
                    return { courses: [] };
                }

                function findActivity(activities, activityID) {
                    var res = findByID(activities, activityID, "activityID");
                    if (res) {
                        return res;
                    }
                    return { reconciliations: [] };
                }

                function selectSemesterID(semesters, semesterID) {
                    return selectIDFromCollection(semesters, semesterID, "semesterID");
                }

                function selectCourseID(courses, courseID) {
                    return selectIDFromCollection(courses, courseID, "courseID");
                }

                function selectActivityID(activities, activityID) {
                    return selectIDFromCollection(activities, activityID, "activityID");
                }

                function selectActivityReconciliationID(reconciliations, activityReconciliationID) {
                    return selectIDFromCollection(reconciliations, activityReconciliationID, "activityReconciliationID");
                }

                function findByID(collection, id, idPropertyName) {
                    for (var i = 0; i < collection.length; i++) {
                        if (collection[i][idPropertyName] === id) {
                            return collection[i];
                        }
                    }
                }

                function selectIDFromCollection(collection, id, idPropertyName) {
                    if (id) {
                        return id;
                    }

                    if (!collection || !collection.length) {
                        return 0;
                    }

                    return collection[0][idPropertyName];
                }

                if ($scope.model.paymentID) {
                    var res = invoiceSvc.getPaymentDetailsByInvoice($scope.model.invoiceForType, $scope.model.invoiceID);
                    res.$promise.then(function (data) {
                        $scope.model.studentID = data.studentID;
                        var amount = $scope.model.amount;
                        var invoiceID = $scope.model.invoiceID;
                        fillCombos(data);
                        $scope.model.amount = amount;
                        $scope.model.invoiceID = invoiceID;
                    });
                } else if ($scope.isAddDuePayment && $scope.model.invoiceID) {
                    $scope.onInvoiceChange($scope.model.invoiceForType, $scope.model.invoiceID)
                }


            }],

            link: function ($scope, $element, attrs, ctrl) {
            }
        }
    }]);